var _circle, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudswithsun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 232,
    viewBox: "0 0 310 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 90,
    r: 55.7826,
    fill: "url(#paint0_linear_2_1134)",
    stroke: "url(#paint1_linear_2_1134)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220 0C217.299 0 215.109 2.18992 215.109 4.89131V20.5435C215.109 23.2449 217.299 25.4348 220 25.4348C222.701 25.4348 224.891 23.2449 224.891 20.5435V4.8913C224.891 2.18991 222.701 0 220 0ZM220 154.565C217.299 154.565 215.109 156.755 215.109 159.457V175.109C215.109 177.81 217.299 180 220 180C222.701 180 224.891 177.81 224.891 175.109V159.457C224.891 156.755 222.701 154.565 220 154.565ZM258.318 13.848C259.669 11.5086 262.66 10.707 265 12.0577C267.339 13.4084 268.141 16.3999 266.79 18.7393L258.964 32.2945C257.614 34.634 254.622 35.4355 252.283 34.0848C249.943 32.7341 249.142 29.7427 250.492 27.4032L258.318 13.848ZM187.717 145.915C185.378 144.564 182.386 145.366 181.036 147.705L173.21 161.261C171.859 163.6 172.66 166.592 175 167.942C177.339 169.293 180.331 168.491 181.682 166.152L189.508 152.597C190.858 150.257 190.057 147.266 187.717 145.915ZM291.261 43.2096C293.6 41.8589 296.592 42.6605 297.942 45C299.293 47.3394 298.491 50.3309 296.152 51.6816L282.597 59.5077C280.257 60.8584 277.266 60.0568 275.915 57.7174C274.564 55.3779 275.366 52.3864 277.705 51.0357L291.261 43.2096ZM164.085 122.283C162.734 119.943 159.743 119.142 157.403 120.492L143.848 128.318C141.509 129.669 140.707 132.66 142.058 135C143.408 137.339 146.4 138.141 148.739 136.79L162.295 128.964C164.634 127.614 165.436 124.622 164.085 122.283ZM305.109 85.1087C307.81 85.1087 310 87.2986 310 90C310 92.7014 307.81 94.8913 305.109 94.8913H289.457C286.755 94.8913 284.565 92.7014 284.565 90C284.565 87.2986 286.755 85.1087 289.457 85.1087H305.109ZM155.435 90C155.435 87.2986 153.245 85.1087 150.543 85.1087H134.891C132.19 85.1087 130 87.2986 130 90C130 92.7014 132.19 94.8913 134.891 94.8913H150.543C153.245 94.8913 155.435 92.7014 155.435 90ZM296.152 128.318C298.491 129.669 299.293 132.66 297.942 135C296.592 137.339 293.6 138.141 291.261 136.79L277.705 128.964C275.366 127.614 274.564 124.622 275.915 122.283C277.266 119.943 280.257 119.142 282.597 120.492L296.152 128.318ZM164.085 57.7174C165.436 55.3779 164.634 52.3864 162.295 51.0357L148.739 43.2096C146.4 41.8589 143.408 42.6605 142.058 45C140.707 47.3394 141.509 50.3309 143.848 51.6816L157.403 59.5077C159.743 60.8584 162.734 60.0568 164.085 57.7174ZM266.79 161.261C268.141 163.6 267.339 166.592 265 167.942C262.66 169.293 259.669 168.491 258.318 166.152L250.492 152.597C249.142 150.257 249.943 147.266 252.283 145.915C254.622 144.564 257.614 145.366 258.964 147.705L266.79 161.261ZM187.717 34.0848C190.057 32.7341 190.858 29.7426 189.508 27.4032L181.682 13.848C180.331 11.5085 177.339 10.7069 175 12.0576C172.66 13.4083 171.859 16.3998 173.21 18.7393L181.036 32.2945C182.386 34.6339 185.378 35.4355 187.717 34.0848Z",
    fill: "url(#paint2_linear_2_1134)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2_1134)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_2_1134",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 58,
    width: 255,
    height: 155,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 15,
    y: 58,
    width: 255,
    height: 155
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.882 129.014C197.882 131.423 197.758 133.804 197.517 136.149C204.953 129.687 214.664 125.775 225.288 125.775C248.68 125.775 267.643 144.738 267.643 168.13C267.643 191.523 248.68 210.486 225.288 210.486H60.6379C60.6256 210.486 60.6133 210.486 60.601 210.486C60.5887 210.486 60.5764 210.486 60.5641 210.486H60.3518V210.485C36.3863 210.351 17 190.882 17 166.885C17 142.976 36.2441 123.562 60.0878 123.287C62.999 87.8508 92.6809 60 128.868 60C166.983 60 197.882 90.8987 197.882 129.014Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.882 129.014C197.882 131.423 197.758 133.804 197.517 136.149C204.953 129.687 214.664 125.775 225.288 125.775C248.68 125.775 267.643 144.738 267.643 168.13C267.643 191.523 248.68 210.486 225.288 210.486H60.6379C60.6256 210.486 60.6133 210.486 60.601 210.486C60.5887 210.486 60.5764 210.486 60.5641 210.486H60.3518V210.485C36.3863 210.351 17 190.882 17 166.885C17 142.976 36.2441 123.562 60.0878 123.287C62.999 87.8508 92.6809 60 128.868 60C166.983 60 197.882 90.8987 197.882 129.014Z",
    fill: "url(#paint3_linear_2_1134)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.517 136.149L195.528 135.945L195.011 140.977L198.829 137.659L197.517 136.149ZM60.3518 210.486H58.3518V212.486H60.3518V210.486ZM60.3518 210.485H62.3518V208.496L60.363 208.485L60.3518 210.485ZM60.0878 123.287L60.1109 125.287L61.932 125.266L62.0811 123.45L60.0878 123.287ZM199.507 136.353C199.755 133.94 199.882 131.492 199.882 129.014H195.882C195.882 131.355 195.762 133.667 195.528 135.945L199.507 136.353ZM225.288 123.775C214.163 123.775 203.991 127.873 196.206 134.639L198.829 137.659C205.915 131.501 215.164 127.775 225.288 127.775V123.775ZM269.643 168.13C269.643 143.634 249.785 123.775 225.288 123.775V127.775C247.576 127.775 265.643 145.843 265.643 168.13H269.643ZM225.288 212.486C249.785 212.486 269.643 192.627 269.643 168.13H265.643C265.643 190.418 247.576 208.486 225.288 208.486V212.486ZM225.288 208.486H60.6379V212.486H225.288V208.486ZM60.601 212.486C60.6079 212.486 60.6146 212.486 60.6207 212.486C60.6269 212.486 60.6324 212.486 60.6379 212.486V208.486C60.631 208.486 60.6242 208.486 60.6182 208.486C60.6119 208.486 60.6064 208.486 60.601 208.486V212.486ZM60.5641 212.486C60.5695 212.486 60.5751 212.486 60.5813 212.486C60.5873 212.486 60.5941 212.486 60.601 212.486V208.486C60.5956 208.486 60.59 208.486 60.5838 208.486C60.5778 208.486 60.571 208.486 60.5641 208.486V212.486ZM60.5641 208.486H60.3518V212.486H60.5641V208.486ZM62.3518 210.486V210.485H58.3518V210.486H62.3518ZM15 166.885C15 191.983 35.2756 212.345 60.3407 212.485L60.363 208.485C37.4971 208.357 19 189.781 19 166.885H15ZM60.0647 121.287C35.1268 121.574 15 141.879 15 166.885H19C19 144.073 37.3614 125.549 60.1109 125.287L60.0647 121.287ZM128.868 58C91.6312 58 61.0902 86.6581 58.0945 123.123L62.0811 123.45C64.9077 89.0436 93.7306 62 128.868 62V58ZM199.882 129.014C199.882 89.7941 168.088 58 128.868 58V62C165.879 62 195.882 92.0033 195.882 129.014H199.882Z",
    fill: "url(#paint4_linear_2_1134)",
    mask: "url(#path-3-outside-1_2_1134)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2_1134",
    x: 0,
    y: 47,
    width: 284.643,
    height: 184.486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_1134"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2_1134",
    result: "effect2_dropShadow_2_1134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2_1134",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1134",
    x1: 250.815,
    y1: 43.0435,
    x2: 201.093,
    y2: 145.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182844,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980542,
    stopColor: "#F09000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1134",
    x1: 192.017,
    y1: 22.6891,
    x2: 269.16,
    y2: 207.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C8D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1134",
    x1: 286.032,
    y1: 23.4782,
    x2: 152.5,
    y2: 180,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1134",
    x1: 94.9027,
    y1: 59.3724,
    x2: 155.193,
    y2: 211.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#9DDCFF",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1134",
    x1: 134.193,
    y1: 7.88894,
    x2: 217.515,
    y2: 272.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#85C6EC",
    stopOpacity: 0.71
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudswithsun);
export default __webpack_public_path__ + "static/media/Clouds with sun.62a17e8c6ab7cc0ecfbcba715358d9dd.svg";
export { ForwardRef as ReactComponent };